import { configureStore } from "@reduxjs/toolkit";
import createSagaMiddleware from "redux-saga";
import { createLogger } from "redux-logger";
import { rootReducer } from "./reducers";
import { rootSaga } from "./sagas";
import type { RootState } from "./reducers";
import { persistStore } from "redux-persist";
import { useDispatch, useSelector, TypedUseSelectorHook } from "react-redux";

const sagaMiddleware = createSagaMiddleware();
const logger = createLogger({
  collapsed: true, // Сворачивает логи в консоли для лучшей читаемости
});

const middleware: any[] = [sagaMiddleware];
if (process.env.NODE_ENV === "development") {
  middleware.push(logger);
}

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      thunk: false,
      serializableCheck: {
        ignoredActions: ["persist/PERSIST", "persist/REHYDRATE"],
      },
    }).concat(middleware),
});

export const persistor = persistStore(store);

sagaMiddleware.run(rootSaga);

// Make store globally accessible for iframe message integration
// This allows the orders reducer to access app state for iframe messaging
if (typeof window !== "undefined") {
  (window as any).__REDUX_STORE__ = store;
}

export type AppDispatch = typeof store.dispatch;
export type { RootState };

// Typed hooks for use throughout the app
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
